import type { DataFields, Variables, Cache } from "@urql/exchange-graphcache";

import { gql } from "urql";

export function adminDeleteUser(
  _result: DataFields,
  args: Variables,
  cache: Cache,
) {
  const USERS_QUERY_CACHE = gql`
    query USERS_QUERY_CACHE {
      adminUsers {
        edges {
          node {
            id
          }
        }
      }
    }
  `;

  cache.updateQuery({ query: USERS_QUERY_CACHE }, (data) => {
    return {
      ...data,
      adminUsers: {
        ...data.adminUsers,
        edges: [
          ...data.adminUsers.edges.filter(
            (edge: { node: { id: string } }) =>
              edge.node.id !== (args.input as { userId: string })?.userId,
          ),
        ],
      },
    };
  });
}
